import React from 'react';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import ListEmpty from '../../components/fragments/ListEmpty';

export default function ScreenDonate() {
    return (
        <ExternalScreen title="Donate">
            <ListEmpty title="Feature coming soon" />
        </ExternalScreen>
    );
}
